module.exports = __webpack_public_path__ + "front/img/65.4d00546e.png";